var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-layout-box"},[_c('list-view',{attrs:{"getList":_vm.getList,"isTabsShow":_vm.isTabsShow,"isButtonShow":_vm.isButtonShow,"buttonList":_vm.buttonList,"listMap":_vm.listMap,"placeholderTitle":_vm.placeholderTitle},on:{"onSeeDetail":_vm.onSeeDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }